//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
let d=[[[0,"RoundoffInsertXYPosition",1,0],[0,"SourceOption",1,0],[0,"StationName",1,0],[0,"TemplateName",1,0],[0,"WizardType",1,0]],[[["paraNames","paraValues"],"SetParameters",{},2,0],[[],"EditSpreadSheet",{},0,0]],[]];
SPLM.Tooling.DieDesignSettingBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.DieDesignSettingBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.DieDesignSettingBuilder.SourceOptions = Object.freeze({
    "FromSpreadsheet" : "FromSpreadsheet", "FromVarPart" : "FromVarPart", "FromCustomerDefault" : "FromCustomerDefault"});

export default SPLM;